/* eslint-disable */
export default {
  hide: 'Verbergen',
  end: 'Beëindigen',
  keypad: 'Toetsenblok',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
